import PropTypes from 'prop-types'
import { StyledEmptyState } from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/CommunicationBoard/styled-components'

const CommunicationBoardEmptyState = ({ t, hidden }) => {
  if (hidden) return null

  return <StyledEmptyState>{t('subscriptionTools:communication_board.no_communications')}</StyledEmptyState>
}

CommunicationBoardEmptyState.propTypes = {
  t: PropTypes.func.isRequired,
  hidden: PropTypes.bool.isRequired,
}

export default CommunicationBoardEmptyState
